import { useSelector } from 'react-redux';

import {
  isQuestAnswerableSelector,
  questExpirationDateSelector,
  questNextResponseDateSelector,
  selectConfigurationParameterById,
} from '!core/redux';
import {
  isTodayAfterGivenDate,
  isTodayEqualOrAfterGivenDate,
} from '»utils/date';

export function useQuestionnaire() {
  const hasQuestionnaire =
    useSelector((state) =>
      selectConfigurationParameterById(state, 'QUESTIONNAIRE'),
    ).value === 'Y';
  const isQuestAnswerable = useSelector(isQuestAnswerableSelector);
  const questNextResponseDate = useSelector(questNextResponseDateSelector);
  const questExpirationDate = useSelector(questExpirationDateSelector);

  return {
    canAnswerQuestInSettings:
      hasQuestionnaire &&
      (isQuestAnswerable ||
        isTodayEqualOrAfterGivenDate(questNextResponseDate) ||
        isTodayAfterGivenDate(questExpirationDate)),
  };
}
